import { z } from "zod";

export const RegisterPushTokenSchema = z.object({
  token: z.string().min(1, "Token is required"),
});

export type RegisterPushTokenRequest = z.infer<typeof RegisterPushTokenSchema>;

export interface PushTokenResponse {
  success: boolean;
  message?: string;
}
